module.exports = __webpack_public_path__ + "img/stanford.66bab4d9.png";